<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i"><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
<h1 style="font-family:Arial;">Part I</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?bef989ae